
import ApplicationForm from "./ApplicationForm";
import LocationBadge from "./LocationBadge";

// Kompakt rad på mobil, kort med bild från md
const JobCard = ({ data }) => {
  return (
    <div className="card flex flex-col overflow-hidden">
      <img className="hidden h-40 w-full object-cover md:block" src={data.image} alt={data.role} />
      <div className="flex flex-1 items-center gap-4 p-4 md:flex-col md:items-stretch md:p-6">
        <div className="flex min-w-0 flex-1 flex-col gap-2 md:gap-4">
          <h4 className="font-semibold text-slate-900 dark:text-white md:text-lg">{data.role}</h4>
          <div className="flex flex-wrap gap-1.5 md:gap-2">
            {data.locations.map((location) => (
              <LocationBadge key={location}>{location}</LocationBadge>
            ))}
          </div>
          {data.description && (
            <p className="hidden text-sm text-slate-600 dark:text-slate-400 md:block">{data.description}</p>
          )}
        </div>
        <div className="shrink-0 md:mt-auto md:pt-2">
          <ApplicationForm role={data.role} buttonClassName="md:w-full" />
        </div>
      </div>
    </div>
  );
};

export default JobCard;
